import React, {Component} from 'react';
import './App.scss';
import CampaignTemplate from "./components/CampaignTemplate";
import EditorWrapper from "./components/EditorWrapper";
import Stepper from "./components/Stepper";
import StepperContent from "./components/StepperContent";
import './config/FontAwesomeIcon';
import CampaignTemplateWrapper from "./containers/CampaignTemplateWrapper";
import Sending from "./components/Sending";
import {inject, observer} from "mobx-react";
import CampaignConfig from "./containers/CampaignConfig";
import {StylesProvider, ThemeProvider} from "@material-ui/styles";
import ElementorTemplate from "./components/ElementorTemplate";


@inject('campaignStore', 'uiStore')
@observer
class App extends Component<any, any> {
    render() {
        return (
            <StylesProvider jss={this.props.uiStore.jss}>
                <ThemeProvider theme={this.props.uiStore.theme}>
                    <div className="App">
                        <StepperContent step={1}>
                            <CampaignConfig/>
                        </StepperContent>

                        <StepperContent step={2}>
                            <CampaignTemplateWrapper>
                                <EditorWrapper/>
                                <CampaignTemplate/>
                            </CampaignTemplateWrapper>
                        </StepperContent>

                        <StepperContent step={3}>
                            <Sending/>
                        </StepperContent>

                        <Stepper setStep={this.props.uiStore.setStep}/>
                    </div>

                </ThemeProvider>
            </StylesProvider>
        );
    }
}

export default (App);
